// components/BlogPostList.jsx
import React from "react";
import { List, Card, Typography, Tag, Space, Button } from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  MessageOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const BlogPostList = ({ posts, loading, onReadMore }) => {
  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      dataSource={posts}
      loading={loading}
      renderItem={(post) => (
        <List.Item>
          <Card
            hoverable
            actions={[
              <Button type="link" onClick={() => onReadMore(post.id)}>
                阅读更多
              </Button>,
            ]}
          >
            <Title level={3}>{post.title}</Title>
            <Space size="middle" style={{ marginBottom: 16 }}>
              <Text type="secondary">
                <UserOutlined /> {post.author}
              </Text>
              <Text type="secondary">
                <CalendarOutlined />{" "}
                {new Date(post.publishedDate).toLocaleDateString()}
              </Text>
              <Text type="secondary">
                <MessageOutlined /> {post.comments?.length || 0} 条评论
              </Text>
              {post.tags &&
                post.tags.map((tag) => (
                  <Tag color="blue" key={tag}>
                    {tag}
                  </Tag>
                ))}
            </Space>
            <div>
              <Text>
                {post.content.length > 300
                  ? post.content.substring(0, 300) + "..."
                  : post.content}
              </Text>
            </div>
          </Card>
        </List.Item>
      )}
    />
  );
};

export default BlogPostList;
